import { combineReducers } from "redux";
import registration from "../reducers";

const rootReducers = combineReducers({
  registration
});

export default rootReducers;
